// https://stackoverflow.com/a/30207330
angular.module('b2bLoginApp.filters').filter('capitalize', function() {
    return function(input) {
        return (angular.isString(input) && input.length > 0) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : input;
    }
});
